import React, { useState } from 'react';
import { useSpring, animated } from "react-spring";
import { app } from './base';

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { makeStyles } from "@material-ui/core/styles";
import { Box, Modal } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import Fade from '@material-ui/core/Fade';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import folder2 from './images/trashFull.png';
import folder1 from './images/trash.png';
import poster from './images/poster.png';
import popUp from './images/poster2.png';
import terminal from './images/terminal.png';
import popUp2 from './images/terminalPopUp.gif';
import sketch from './images/sketch.png';
import popUp3 from './images/sketchPopUp.png';
import readme from './images/readme.png';
import popUp4 from './images/readmePopUp.png';
import bg from './images/bg.jpg';
import trash from './images/trashfooter.gif'
import starIcon  from './images/star.svg'
var ReactRotatingText = require('react-rotating-text');

const useStyles = makeStyles({
  bgSetup: {
    backgroundImage: `url(${bg})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: "center center",
    backgroundSize: "cover",
    position: 'absolute',
    maxWidth:'600px',
    width: '100%',
    height: '100%',
    display: 'flex', 
    flexWrap: 'wrap', 
    overflow: 'hidden',
  },

  buttons:{
    position: 'absolute',
    display:'flex',
    flexDirection:'row',
    flexWrap: 'wrap',
    padding: '5',
    margin: '5',
  },

  statusbar:{
    marginTop:4,
    position: 'absolute',
    display:'flex', 
    // flexDirection:'row',
    // flexWrap: 'wrap',
    alignItems:'center',
    fontSize:'.8em',
    // opacity:0.2,
    // backgroundColor: 'rgb(255,255,255)',
    width:'100%',
    height:'5%',
    borderColor:'rgb(0,0,0)',
    border:0,
    borderBottom:'1px solid', 
  },

  starIcon:{
    backgroundImage: `url(${starIcon})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: "center center",
    backgroundSize: "cover",
    width:'1.2em',
    height:'1.2em',
  },

  texts:{
    fontFamily: 'Work Sans',
    fontSize:'1.5em',
    fontWeight:'400',
  },

  trashButton: {
    marginLeft:'2em',
    marginRight:'1.2em',
    marginTop: '5em',
    position: 'relative',
    background: 'none',
    width: '90px',
    height: '130px',
    color: 'rgba(0, 0, 0, 0)',
    backgroundImage: `url(${folder2})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: "center center",
  },

  posterButton:{
    marginLeft:'1.2em',
    marginRight:'1.2em',
    marginTop: '5em',
    background:'none',
    width: '90px',
    height: '130px',
    color: 'rgba(0, 0, 0, 0)',
    backgroundImage: `url(${poster})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: "center center",
    position: 'relative',
  },
  
  posterModal:{
    position: 'absolute',
    top:'45%',
    left:'51%',
    transform: 'translate(-50%, -50%)',
    backgroundImage: `url(${popUp})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: "center center",
    backgroundSize: "100%",
    width: '100%',
    height: '100%',
    // maxHeight:200
  },

  terminalButton: {
    marginLeft:'1.2em',
    marginRight:'2em',
    marginTop: '1em',
    background: 'none',
    width: '90px',
    height: '130px',
    color: 'rgba(0, 0, 0, 0)',
    backgroundImage: `url(${terminal})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: "center center",
    position: 'relative',
    // '&:hover': {
    //   background: 'rgba(0,0,0,0)',
    //   color: 'rgba(0, 0, 0, 0)',
    //   backgroundImage: `url(${terminal})`,
    //   backgroundRepeat: 'no-repeat',
    //   backgroundPosition: "center center",
    // },
    // '&:active': {
    //   background: 'rgba(0,0,0,0)',
    //   color: 'rgba(0, 0, 0, 0)',
    //   boxShadow: 'none',
    //   backgroundImage: `url(${terminal})`,
    //   backgroundRepeat: 'no-repeat',
    //   backgroundPosition: "center center",
    // },
  },
  terminalModal: {
    position: 'absolute',
    top: '46%',
    left: '51%',
    transform: 'translate(-50%, -50%)',
    backgroundImage: `url(${popUp2})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: "center center",
    backgroundSize: "110%",
    width: '100%',
    height: '100%',
    // maxHeight:200
  },
  sketchButton: {
    marginLeft:'2em',
    marginRight:'1.2em',
    marginTop: '1em',
    background: 'none',
    width: '90px',
    height: '130px',
    color: 'rgba(0, 0, 0, 0)',
    backgroundImage: `url(${sketch})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: "center center",
    position: 'relative',
  },
  sketchModal: {
    position: 'absolute',
    top: '46%',
    left: '49%',
    transform: 'translate(-50%, -50%)',
    backgroundImage: `url(${popUp3})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: "center center",
    backgroundSize: "110%",
    width: '100%',
    height: '100%',
    // maxHeight:200
  },
  readmeButton: {
    marginLeft:'1.2em',
    marginRight:'1.2em',
    marginTop: '5em',
    background: 'none',
    width: '90px',
    height: '130px',
    color: 'rgba(0, 0, 0, 0)',
    backgroundImage: `url(${readme})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: "center center",
    position: 'relative',
  },
  readmeModal: {
    position: 'absolute',
    top: '46%',
    left: '49%',
    transform: 'translate(-50%, -50%)',
    backgroundImage: `url(${popUp4})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: "center center",
    backgroundSize: "110%",
    width: '100%',
    height: '100%',
    // maxHeight:200
  },

  blurLayer: {
    background: 'inherit',
    backgroundSize: "cover",
    width: '100%',
    height: '100%',
    position: 'absolute',
    filter: 'blur(7px)',
    overflow: 'hidden',
  },

  trashFooter:{
    width: '100%',
    height: '100%',
    backgroundImage: `url(${trash})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left bottom',
    position: 'absolute',
    overflow: 'hidden',
  },

  dialog: {
    maxWidth:300,
    width:'60%',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px',
    textAlign: "center",    
  },
  customDialogContent:{
    fontFamily: 'Work Sans',
    fontSize:'14px',
    fontWeight:'400',
    marginBottom: '0px',
    marginTop: '5px',
    lineHeight:'22px',
  },
  customDialogAction: {
    backgroundColor: 'rgba(0,0,0,0)',
    width:100,
    fontFamily: 'Work Sans',
    fontSize: '14px',
    fontWeight: '600',
  }
});
const randomInRange = (min, max) => {
  return Math.random() * (max - min) + min;
};

export default function App() {
  const [background, setBackground] = useState(folder1);
  const [file, setFile] = useState(null);
  const [url, setURL] = useState("");
  const [on, setON] = useState(false);
  const [ing, setMoving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(null);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [openModal4, setOpenModal4] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [state, isDragging] = React.useState(false);
  const hiddenFileInput = React.useRef(null);
  const classes = useStyles();
  const storage = app.storage();
  const database = app.database();

  const styles = useSpring({
    loop: false,
    reset: on,
    config: { duration: 7000 },
    from: { x: window.innerWidth/4, y: -250, rotateZ: randomInRange(90, 120) },
    to: { x: window.innerWidth/4, y: window.innerHeight+50, rotateZ: randomInRange(60, 80) },
  });
  const starSVG = useSpring({
    loop: true,
    config: { duration: 7000 },
    from: { rotate: 0 },
    to: { rotate:360 },
  });

  function reName(name) {
    const fileName = name.split('.');
    const nn = fileName.slice(0, fileName.length - 1).join('.');
    console.log(name);
    return nn.replace(/ /g, '%');
  };

  function urle(e) {
    const rename = reName(file.name);
    setTimeout(() => {   
      setURL(`https://storage.googleapis.com/wet-data.appspot.com/${rename}_200x200.jpeg`);
      setON(true);
      imgMoving();
    }, 3000);
  }
  function imgMoving(e){
    setON(false);
    setMoving(true);
    setTimeout(() => {
      setMoving(false);
      setURL(null);
    }, 7000)
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setLoading(false);
    setOpenModal(false);
    setOpenModal2(false);
    setOpenModal3(false);
    setOpenModal4(false);
  };

  function openModalHandler(number){
    const nowNumber = number;
    if(nowNumber === 1){
      setOpenModal(1);
    } else if (nowNumber === 2){
      setOpenModal2(true);
    } else if (nowNumber === 3) {
      setOpenModal3(true);
    }else if (nowNumber === 4) {
      setOpenModal4(true);
    }
  };

  function handleClick(e) {
    if (state ===false) return hiddenFileInput.current.click();
    setTimeout(() => (isDragging(false)), 0);
    // hiddenFileInput.current.click();
  };

  function handleChange(e) {
    handleClickOpen();
    setFile(e.target.files[0]);
  };

  function handleUpload(e) {
    e.preventDefault();
    setLoading(true);
    setOpen(false);
    const newImage = storage.ref().child(file.name);
    const uploadImage = database.ref('urls').push();
    const uploadTask = newImage.put(file);
    const rename = reName(file.name);
    console.log(rename);
    uploadTask.on("state_changed", console.log, console.error, () => {
      newImage
        .getDownloadURL()
        .then((url) => {
          setFile(null);
          uploadImage.set(`https://storage.googleapis.com/wet-data.appspot.com/${rename}_200x200.jpeg`);
          
          setLoading(false);
          setBackground(folder2);
          urle();
        });
    });
  }

  return (

    <React.Fragment>
      <CssBaseline />
      <Container maxWidth="sm" disableGutters={true} style={{
        height: '100%',
        overflow: 'hidden',
        width: '100%' }}>
        <Typography component="div" className={classes.bgSetup}  >
          <Box component='div' sx={{ p: 0, zIndex: 'app bar' }} className={classes.blurLayer}>
            <animated.div
              style={{
                width: 200,
                height: 200,
                position: 'absolute',
                backgroundImage: `url(${url})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: "center center",
                backgroundSize: 'contain',
                ...styles,
              }}
            />
          </Box>
          
          <Box component='div' sx={{ p: 0, zIndex: 'modal' }} className={classes.trashFooter} />
          <Box classes={classes.buttons} sx={{ zIndex: 'tooltip'}} >
        
            <Button className={classes.trashButton} onClick={handleClick} disableRipple/>
            <input type="file" ref={hiddenFileInput} onChange={handleChange} style={{ display: 'none' }} />
          
            <Button className={classes.posterButton} onClick={() => openModalHandler(1)} disableRipple/>

            <Button className={classes.readmeButton} onClick={() => openModalHandler(4)} disableRipple/>
        
            <Button className={classes.sketchButton} onClick={() => openModalHandler(3)} disableRipple/>
            <Button className={classes.terminalButton} onClick={() => openModalHandler(2)} disableRipple/>
            
            
          </Box>
          <Box className={classes.statusbar} sx={{ p:1 }} mt={0} ml={0}>
          <animated.span style={starSVG} className={classes.starIcon}/>
            <animated.span style={starSVG} className={classes.starIcon}/> &nbsp;
            <ReactRotatingText className={classes.texts} items={['First. Touch the My folder button', ' Second. Upload a photo', ' Third. Wait for the falling photo']} />
          </Box>
          <Modal open={openModal} onClose={handleClose} closeAfterTransition aria-describedby="modal-modal-description" hideBackdrop={true}>
            <Fade in={openModal} >
              <Box className={classes.posterModal} onClick={handleClose} />
            </Fade>
          </Modal>
          <Modal open={openModal2} onClose={handleClose} closeAfterTransition aria-describedby="modal-modal-description" hideBackdrop={true}>
            <Fade in={openModal2} >
              <Box className={classes.terminalModal} onClick={handleClose} />
            </Fade>
          </Modal>
          <Modal open={openModal3} onClose={handleClose} closeAfterTransition aria-describedby="modal-modal-description" hideBackdrop={true}>
            <Fade in={openModal3} >
              <Box className={classes.sketchModal} onClick={handleClose} />
            </Fade>
          </Modal>
          <Modal open={openModal4} onClose={handleClose} closeAfterTransition aria-describedby="modal-modal-description" hideBackdrop={true}>
            <Fade in={openModal4} >
              <Box className={classes.readmeModal} onClick={handleClose} />
            </Fade>
          </Modal>
          <Dialog
            open={open} onClose={handleClose} aria-describedby="alert-dialog-description" classes={{ paper: classes.dialog }}>
            <DialogContent >
              <DialogContentText id="alert-dialog-description" disableTypography="true" classes={{ root: classes.customDialogContent }}>
                Do you want to save <br/>
                the selected image?
              </DialogContentText>
            </DialogContent>
            <DialogActions style={{ alignItems: 'center'}}>
              <Button type='submit' onClick={handleUpload} color='black' disableRipple disableTypography="true" classes={{ root: classes.customDialogAction }}>
                Yes
              </Button>
              <Button onClick={handleClose} autoFocus color='black' disableRipple disableTypography="true" classes={{ root: classes.customDialogAction }}>
                No
              </Button>
            </DialogActions>
          </Dialog>
        </Typography>
      </Container>
    </React.Fragment>
  );
}
//https://dev.to/itnext/how-to-do-image-upload-with-firebase-in-react-cpj
//https://dev.to/itnext/how-to-do-image-upload-with-firebase-in-react-cpj